import { HttpContextToken, HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastController } from '@ionic/angular';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { MonitoringService } from '@mom/shared';

export const SkipForbiddenRedirect = new HttpContextToken<boolean>(() => false);

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    private monitoringService: MonitoringService,
    private router: Router,
    private toastController: ToastController
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err) {
          switch (err.status) {
            case 400:
              // This code should be handled on each http call as the handled response could be diferent.
              break;
            case 401:
            case 403:
              if (!request.context.get(SkipForbiddenRedirect)) {
                this.router.navigate(['access-forbidden'], { replaceUrl: true });
              }
              break;
            case 429:
              this.showToast('You need to slow down. Try again in a minute.', 'warning');
              break;
            case 500:
              this.monitoringService.logException(err);
              this.showToast('There was an error. Please try again later', 'warning');
              break;
            case 0:
            case 503:
              this.showToast('No internet connection', 'wifi-outline');
              break;
            default:
              break;
          }
          return throwError(err);
        }
      })
    );
  }

  private async showToast(toastMessage: string, icon?: string): Promise<void> {
    const toast = await this.toastController.create({
      message: toastMessage,
      duration: 3000,
      position: 'top',
      icon: icon,
      color: 'warning'
    });

    await toast.present();
  }
}
